import { Outlet, Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LaptopIcon, LayoutDashboardIcon, UsersIcon, FileTextIcon, LogOutIcon, UserSearchIcon, SettingsIcon } from 'lucide-react';

export default function Layout({ onLogout }) {
  const location = useLocation();

  const navigation = [
    { name: 'Dashboard', href: '/', icon: LayoutDashboardIcon },
    { name: 'Devices', href: '/devices', icon: LaptopIcon },
    { name: 'Customers', href: '/customers', icon: UsersIcon },
    { name: 'Customer Devices', href: '/customer-devices', icon: UserSearchIcon },
    { name: 'Rentals', href: '/rentals', icon: FileTextIcon },
    { name: 'Users', href: '/users', icon: UsersIcon, adminOnly: true },
    { name: 'Settings', href: '/settings', icon: SettingsIcon }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <aside className="w-64 bg-white border-r border-gray-200 flex flex-col" data-testid="sidebar">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center space-x-2">
            <img 
              src="/logo.jpg" 
              alt="Laptop On Rent.biz" 
              className="h-12 w-auto rounded"
            />
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-2">
          {navigation.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive(item.href)
                    ? 'bg-primary text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
                data-testid={`nav-${item.name.toLowerCase()}`}
              >
                <Icon className="h-5 w-5" />
                <span className="font-medium">{item.name}</span>
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-gray-200">
          <Button
            variant="ghost"
            className="w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50"
            onClick={onLogout}
            data-testid="logout-button"
          >
            <LogOutIcon className="h-5 w-5 mr-3" />
            Logout
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}